var fileDownload = require("js-file-download");

import Vue from "vue";
const vm = Vue.prototype;

import $i18n from "../i18n";

import checkApp from "../service/check-application.js";

const statuses = ["", "/not_paid", "/half_paid", "/paid"];

export const state = () => ({
  applications: [],
  count: [],
  application: checkApp(),
  faculties: [],
});

export const mutations = {
  SET_APPLICATIONS(state, payload) {
    state.applications = vm.$toArray(payload);
  },

  SET_COUNT(state, payload) {
    state.count = payload || {};
  },

  SET_BY_ID(state, payload) {
    state.application = checkApp(payload);
  },

  MOVE_TO_2025(state, payload) {
    state.payments = vm.$toArray(payload);
  },

  MOVE_ALL_TO_2025(state, payload) {
    state.payments = vm.$toArray(payload);
  },

  SET_FACULTIES(state, payload) {
    state.faculties = vm.$toArray(payload);
  },
};

export const actions = {
  async INIT_APPLICATIONS({ commit }, options) {
    const { itemsPerPage, search = "", sortBy = [], sortDesc = [] } = options;

    const page = Number(options.page - 1) || 0;
    const sortField = sortBy.length ? sortBy[0] : "";
    const sortOrder = sortDesc.length && sortDesc[0] ? "desc" : "asc";

    const senc = search ? encodeURI(search) : null;

    const query = `?page=${page}&size=${itemsPerPage}&name=${senc}&sortField=${sortField}&sortOrder=${sortOrder}`;
    let totalItemsCount = 0;

    const status = statuses[options.status] || "";

    const data = await vm.$axios.$get(`admin/contract2023${status}${query}`);

    if (data) {
      commit("SET_APPLICATIONS", data.content);

      totalItemsCount = data.totalElements;
    }

    return totalItemsCount;
  },

  async INIT_FILTERED_APPLICATIONS({ commit }, { filters, options }) {
    const { itemsPerPage, search = "", sortBy = [], sortDesc = [], page = 1, status } = options;

    const pageNum = Number(page - 1) || 0;
    const sortField = sortBy.length ? sortBy[0] : "";
    const sortOrder = sortDesc.length && sortDesc[0] ? "desc" : "asc";
    const senc = search ? encodeURI(search) : null;
    const statusStr = statuses[status] || "";

    const query = `?page=${pageNum}&size=${itemsPerPage}&name=${senc}&sortField=${sortField}&sortOrder=${sortOrder}`;

    const res = await vm.$axios.$post(`admin/contract2023/filter${statusStr}${query}`, filters);

    if (res) {
      commit("SET_APPLICATIONS", res.content);
      return res.totalElements;
    }

    return 0;
  },

  async EXPORT_EXCEL(ctx, options) {
    const status = statuses[options.status] || "";

    const res = await vm.$axios.$getBlob2(`admin/contract2023/export${status}`);

    if (res?.data) {
      const ss = `${status || ""}`.replace("/", "");
      const file_name = `${ss?.trim() ? ss : "all"}_contracts`;
      const date = new Date().toISOString().substr(0, 10);
      fileDownload(res.data, `${file_name}_${date}.xlsx`);
    }

    return true;
  },

  async EXPORT_EXCEL_BY_FILTER(_, { filters, status }) {
    const statusStr = statuses[status] || "";
    const res = await vm.$axios.$postBlob2(`admin/contract2023/export/filter${statusStr}`, filters);

    if (res?.data) {
      const ss = `${statusStr || ""}`.replace("/", "");
      const file_name = `${ss?.trim() ? ss : "all"}_contracts`;
      const date = new Date().toISOString().substr(0, 10);
      fileDownload(res.data, `${file_name}_${date}.xlsx`);
    }

    return true;
  },

  async EXPORT_EXCEL_PAID() {
    const status = "/passed";
    const res = await vm.$axios.$getBlob2(`admin/application/export${status}`);

    if (res?.data) {
      const ss = `${status || ""}`.replace("/", "");
      const file_name = `${ss?.trim() ? ss : "all"}_application`;
      const date = new Date().toISOString().substr(0, 10);
      fileDownload(res.data, `${file_name}_${date}.xlsx`);
    }

    return true;
  },

  async INIT_FACULTIES({ commit }) {
    try {
      const faculties = await vm.$axios.$get("admin/faculty/all");
      commit("SET_FACULTIES", faculties);
      return faculties;
    } catch (error) {
      console.error("Fakultetlarni yuklashda xatolik:", error);
      commit("SET_FACULTIES", []);
      return [];
    }
  },

  async INIT_COUNT({ commit }) {
    const data = await vm.$axios.$get(`admin/contract2023/count`);
    commit("SET_COUNT", data);
    return data != null;
  },

  async PAID_APPLICATION({ dispatch }, { id }) {
    if (id) {
      const res = await vm.$axios.$post(`admin/contract2023/convert/${id}`);

      const status = res != null;
      if (status) {
        dispatch(
          "SET_SNACKBAR",
          {
            text: $i18n.t("Success"),
            color: "success",
          },
          { root: true }
        );
      }
      return status;
    } else return null;
  },

  async REJECT_APPLICATION({ dispatch }, { id, reviews }) {
    if (id) {
      const res = await vm.$axios.$post(
        `admin/application/${id}/rejects`,
        reviews
      );

      const status = res != null;
      if (status) {
        dispatch(
          "SET_SNACKBAR",
          {
            text: $i18n.t("Success"),
            color: "success",
          },
          { root: true }
        );
      }
      return status;
    } else return null;
  },

  async DELETE_APPLICATION({ dispatch }, { id }) {
    if (id) {
      const res = await vm.$axios.$delete(`admin/contract2023/${id}`);

      const status = res != null;
      if (status) {
        dispatch(
          "SET_SNACKBAR",
          {
            text: $i18n.t("Success"),
            color: "success",
          },
          { root: true }
        );
      }
      return status;
    } else return null;
  },

  async INIT_BY_ID({ commit }, { id }) {
    if (id) {
      const data = await vm.$axios.$get(`admin/contract2023/open/${id}`);
      if (data) data.id = Number(id);

      commit("SET_BY_ID", data);
      return data != null;
    }
  },
  
  async MOVE_TO_2025(_, id) {
    const url = `/admin/contract2023/move/2025?id=${id}`;
    // const params = { id };

    const result = await vm.$axios.$post(url);
    return result;
  },

  async MOVE_ALL_TO_2025() {
    const url = `/admin/contract2023/move/2025/all`;

    const result = await vm.$axios.$post(url);
    return result;
  },
  
  async DELETE_ALL({ dispatch }) {
    const res = await vm.$axios.$delete(`admin/contract2023/delete/all`);

    const status = res != null;
    if (status) {
      dispatch(
        "SET_SNACKBAR",
        {
          text: $i18n.t("Success"),
          color: "success",
        },
        { root: true }
      );
    }
    return status;
  },

  async DROP_ALL({ dispatch }) {
    try {
      await vm.$axios.$put(`admin/contract2023/dropout/all`);
      dispatch("SET_SNACKBAR", { text: $i18n.t("Success"), color: "success" }, { root: true });
      return true;
    } catch (e) {
      dispatch("SET_SNACKBAR", { text: $i18n.t("Error"), color: "error" }, { root: true });
      return false;
    }
  },

  async FETCH_FILTERED_IDS(_, { filters, status, search }) {
    const statusStr = statuses[status] || "";
    const senc = search ? encodeURI(search) : null;
    const query = `?page=0&size=999999&name=${senc}&sortField=&sortOrder=asc`;
    const url = filters
      ? `admin/contract2023/filter${statusStr}${query}`
      : `admin/contract2023${statusStr}${query}`;
    const res = filters
      ? await vm.$axios.$post(url, filters)
      : await vm.$axios.$get(url);
    return (res?.content || []).map((c) => c.id);
  },

  async DROP_BY_IDS({ dispatch }, ids) {
    if (!ids || !ids.length) return false;
    try {
      await vm.$axios.$put(`admin/contract2023/dropout/by-ids`, ids);
      dispatch("SET_SNACKBAR", { text: $i18n.t("Success"), color: "success" }, { root: true });
      return true;
    } catch (e) {
      dispatch("SET_SNACKBAR", { text: $i18n.t("Error"), color: "error" }, { root: true });
      return false;
    }
  },

  async DELETE_BY_IDS({ dispatch }, ids) {
    if (!ids || !ids.length) return false;
    try {
      await vm.$axios.$delete(`admin/contract2023/by-ids`, { data: ids });
      dispatch("SET_SNACKBAR", { text: $i18n.t("Success"), color: "success" }, { root: true });
      return true;
    } catch (e) {
      dispatch("SET_SNACKBAR", { text: $i18n.t("Error"), color: "error" }, { root: true });
      return false;
    }
  },

  async MOVE_BY_IDS_TO_2025({ dispatch }, ids) {
    if (!ids || !ids.length) return false;
    try {
      await vm.$axios.$post(`admin/contract2023/move/2025/by-ids`, ids);
      dispatch("SET_SNACKBAR", { text: $i18n.t("Success"), color: "success" }, { root: true });
      return true;
    } catch (e) {
      dispatch("SET_SNACKBAR", { text: $i18n.t("Error"), color: "error" }, { root: true });
      return false;
    }
  },

  async RESTORE_BY_IDS({ dispatch }, ids) {
    if (!ids || !ids.length) return false;
    try {
      await vm.$axios.$put(`admin/contract2023/dropout/restore/by-ids`, ids);
      dispatch("SET_SNACKBAR", { text: $i18n.t("Success"), color: "success" }, { root: true });
      return true;
    } catch (e) {
      dispatch("SET_SNACKBAR", { text: $i18n.t("Error"), color: "error" }, { root: true });
      return false;
    }
  },
};

export const getters = {
  GET_APPLICATIONS: (state) => state.applications,
  GET_COUNT: (state) => state.count,
  GET_APPLICATION: (state) => state.application,
  
};
